import { render, staticRenderFns } from "./MyAddress_Component.vue?vue&type=template&id=21023260&scoped=true&"
import script from "./MyAddress_Component.vue?vue&type=script&lang=js&"
export * from "./MyAddress_Component.vue?vue&type=script&lang=js&"
import style0 from "./MyAddress_Component.vue?vue&type=style&index=0&id=21023260&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21023260",
  null
  
)

export default component.exports